<template>
  <div>
    <el-table v-loading="!ready" :data="tableData" border size="mini" :resizable="false">
      <el-table-column label="操作" prop="operation" width="50">
        <template slot-scope="scope">
          <el-button v-if="scope.row.rid" type="text" size="mini" @click="showRadish(scope.row.rid)">查看</el-button>
          <el-button v-else type="text" size="mini" @click="bindRadish(scope.row)">绑定</el-button>
        </template>
      </el-table-column>
      <el-table-column v-for="item in fields" :label="item.label" :prop="item.prop" :key="item.prop"> </el-table-column>
    </el-table>
    <BindDialog ref="BindDialog" :onSuccess="onSuccess"></BindDialog>
  </div>
</template>
<script>
const dateFormat = require('dateformat')
import BindDialog from '../dialog/radish-bind-dialog'
export default {
  components: { BindDialog },
  props: {
    query: { type: Object, default: {} },
    fields: { type: Array, default: [{ label: '姓名', prop: 'name' }] },
  },
  data() {
    return {
      tableData: [],
      ready: false,
    }
  },
  methods: {
    async loadData() {
      this.ready = false
      const res = await app.service('radish').listManagers({ query: this.query })
      if (res.status === 'success') {
        this.tableData = res.data.map(m => {
          if (m.positionStartDate) {
            m.positionStartDate = dateFormat(new Date(m.positionStartDate), 'yyyy-mm-dd')
          }
          if (m.positionDuration) {
            m.positionDuration = m.positionDuration.toFixed(1) + '年'
          }
          if (m.maxPositionDuration) {
            m.maxPositionDuration = m.maxPositionDuration.toFixed(1) + '年'
          }
          if (m.latestFundScale) {
            m.latestFundScale = (m.latestFundScale / 100000000).toFixed(2) + '亿'
          }
          if (m.latestFundScale) {
            m.latestFundScale = (m.maxFundScale / 100000000).toFixed(2) + '亿'
          }
          return m
        })
      } else {
        this.$message.error(res.msg)
      }
      this.ready = true
    },
    showRadish(id) {
      window.open(`${window.frontend}/#/radish-detail-blank/${id}`, '_blank')
    },
    bindRadish(row) {
      this.$refs.BindDialog.show(row)
    },
    onSuccess(id, rid) {
      this.ready = false
      this.tableData = this.tableData.map(dt => {
        if (dt._id === id) {
          dt.rid = rid
        }
        return dt
      })
      this.ready = true
    },
  },
  created() {
    this.loadData()
  },
}
</script>
